<template>
  <a-card v-if="queryList">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form" :class="!editEnable ? 'readyOnly':''">
        <a-row :gutter="16" v-for="(item,index) in queryParam" :key="index" style="margin-bottom: 5px">
          <a-col :span="6" :offset="1">
            <a-form-item label="安装类别">
              <a-select  v-model="item.installType" @change="handleOrder(index,$event)">
                <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" :offset="1">
            <a-form-item label="订单类型">
              <a-select  v-model="item.orderType" style="width:100%">
                <a-select-option  v-for="tet in item.restaurantTypes2" :key="tet.orderTypeId">{{tet.typeName}}</a-select-option>
              </a-select>
              <span style="margin-left:15px;color: red;" v-if="item.isType">订单类型重复</span>
            </a-form-item>
          </a-col>
          <a-col :span="6" :offset="1">
            <a-form-item label="审核差值" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="item.price"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="3" style="text-align: right">
            <a-button type="danger"  style="margin:0 20px;" @click="removeTab1(item)">删除</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8" :offset="11" style="margin-top: 20px">
            <a-button type="primary"  @click="handleAdd">新增</a-button>
            <a-button type="primary" style="margin-left: 8px;" @click="handleSave">保存</a-button>
            <!--<a-button style="width:120px;">取消</a-button>-->
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-card>
  <no-authority v-else></no-authority>
</template>

<script>
  import { getOrderTypeList,getList,getSave } from '@/api/basicdatas/Configuration'
  import { checkPermission } from '@/utils/permissions'
  import NoAuthority from '../enterprise/NoAuthority'
  import {getDictMap} from "../../utils/dict"

  export default {
    name: "ReviewDifference",
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        queryParam:[],
        restaurantTypes:[],
        restaurantOperTypeMap:[],
        queryList: checkPermission('basicdata:ReviewDifference:query'),
        editEnable: checkPermission('basicdata:ReviewDifference:edit'),
      }
    },
    components: {
      NoAuthority
    },
    async created () {
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
      var that=this
      getList().then(res=>{
        console.log(res.rows)
        let rows = res.rows
        for(let i=0;i<rows.length;i++){
          let str = {}
          // console.log('数组以及',rows[i],rows[i].installType)
          getOrderTypeList(rows[i].installType).then(res1=>{
            str.restaurantTypes2 = res1.rows
            console.log('订单类型',str.restaurantTypes2)

          }).then(res1=>{
            str.installType = rows[i].installType
            str.orderType = rows[i].orderType
            str.price = rows[i].price
            str.isType = false
            that.queryParam.push(str)
          })
        }
        console.log('提交',this.queryParam)
      })
    },
    methods: {
      handleAdd(){
        this.queryParam.push({
          installType:"",
          orderType:"",
          price:"",
          isType:false,
          restaurantTypes2:[]
        })
      },
      handleOrder(index,value){
        console.log(index,value)
        console.log(this.queryParam[index])
        this.queryParam[index].orderType = ''
        this.queryParam[index].restaurantTypes2 = []
        getOrderTypeList(value).then(res => {
          this.queryParam[index].restaurantTypes2 = res.rows
          console.log(this.queryParam[index].restaurantTypes2)
        })
      },
      handleSave(){
        console.log(this.queryParam)
        for(let k=0;k<this.queryParam.length;k++){
          this.queryParam[k].isType = false
        }
        for(let i=0;i<this.queryParam.length-1;i++){
          for(let j=i+1;j<this.queryParam.length;j++){
            if((this.queryParam[i].orderType == this.queryParam[j].orderType)&&this.queryParam[i].orderType!=''&&this.queryParam[j].orderType!='' ){
              this.queryParam[i].isType = true
              this.queryParam[j].isType = true
            }
          }
        }
        console.log(this.queryParam,this.queryParam)
        getSave(this.queryParam).then(res=>{
          if (res.code === 0) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },
      // 删除
      removeTab1(item){
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            let index = that.queryParam.indexOf(item);
            if (index !== -1) { //当没有多余tab时就不再删除
              that.queryParam.splice(index, 1)
            }
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      },
    },
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
  .readyOnly{
    pointer-events: none;
  }
</style>